import { render, staticRenderFns } from "./inbox.vue?vue&type=template&id=4db0b279&scoped=true"
import script from "./inbox.vue?vue&type=script&lang=js"
export * from "./inbox.vue?vue&type=script&lang=js"
import style0 from "./inbox.vue?vue&type=style&index=0&id=4db0b279&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db0b279",
  null
  
)

export default component.exports